import { useLocale } from 'hooks/useLocale/useLocale';
import { HistoryList } from 'ui/historyList/HistoryList';
import { useLocaleStoreQuery } from 'hooks/useLocaleStoreQuery/useLocaleStoreQuery';
import { filterQueryFromPagination } from 'helpers/filterQueryFromPagination';
import { AppMessages } from 'i18n/messages';

import { UsersLoginHistoryFilters } from './usersLoginHistoryFilters/UsersLoginHistoryFilters';
import { UsersLoginHistoryProps } from './UsersLoginHistory.types';

export const UsersLoginHistory = ({
  historyResponse,
  isLoading,
  page,
  setPage,
  rowsPerPage,
  setRowsPerPage,
  userSearchQuery,
  setUserSearchQuery,
  onClearHistoryQuery,
}: UsersLoginHistoryProps) => {
  const { formatMessage } = useLocale();

  const {
    storedQueries: { usersLoginHistory: usersLoginHistoryQuery },
  } = useLocaleStoreQuery();

  const isClearFiltersButtonVisible =
    Object.values(filterQueryFromPagination(usersLoginHistoryQuery)).some((query) => query) || !!userSearchQuery;

  return (
    <HistoryList
      data={historyResponse?.data || []}
      isLoading={isLoading}
      filters={{
        isClearButtonVisible: isClearFiltersButtonVisible,
        onClearFilters: onClearHistoryQuery,
        render: () => (
          <UsersLoginHistoryFilters userSearchQuery={userSearchQuery} setUserSearchQuery={setUserSearchQuery} />
        ),
      }}
      pagination={{
        page,
        setPage,
        rowsPerPage,
        setRowsPerPage,
        count: historyResponse?.count || 0,
      }}
      renderHistoryItemBody={(history) => (
        <>
          {history.username && (
            <HistoryList.ActionBodyItem
              title={formatMessage({ id: AppMessages['users.loginHistory.name'] })}
              value={history.username}
            />
          )}

          {history.imie && history.nazwisko && (
            <HistoryList.ActionBodyItem
              title={formatMessage({ id: AppMessages['users.loginHistory.fullName'] })}
              value={`${history.nazwisko} ${history.imie}`}
            />
          )}

          {history.powod && (
            <HistoryList.ActionBodyItem
              title={formatMessage({ id: AppMessages['users.loginHistory.reason'] })}
              value={history.powod}
            />
          )}
        </>
      )}
    />
  );
};
